<ion-header>
  <!-- <div class="PropertyWorkflowModal__HeaderRow row">
      <div class="col"> -->
  <ion-toolbar color="primary">
    <ion-title>New Property</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="AddPropertyModal">
  <section class="AddPropertyModal__Content">
    <h1 class="AddPropertyModal__Title">Search for your property:</h1>

    <form [formGroup]="searchForm">
      <!-- must use standard input for Google Search -->
      <input
        class="AddPropertyModal__SearchInput"
        id="ship-address"
        name="ship-address"
        label="Search Here"
        required
        autocomplete="off"
        formControlName="searchText"
        tabindex="0"
      />
    </form>
    <!-- Individual Editable Fields -->
    <form class="AddPropertyModal__Form" [formGroup]="addPropertyForm">
      @for (field of fieldList; track field; let i = $index) {
        <ng-container
          dynamicField
          [field]="field"
          [group]="addPropertyForm"
          [className]="'AddPropertyModal__' + field.name + 'Field'"
        >
          @if (i !== 3) {
            <div class="break"></div>
          }
        </ng-container>
      }
    </form>
  </section>
</ion-content>

<ion-footer class="AddPropertyModal__Footer">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        class="AddPropertyModal__Button"
        fill="outline"
        color="medium"
        (click)="cancelAddNew()"
      >
        Cancel
      </ion-button>
      <ion-button
        id="add-property-button"
        data-test-id="addPropertyButton"
        class="AddPropertyModal__Button"
        fill="solid"
        color="primary"
        [disabled]="addPropertyForm.invalid || addPropertyForm.pristine"
        (click)="saveNewProperty()"
        [ngClass]="{
          'AddPropertyModal__Button--disabled': addPropertyForm.invalid,
        }"
        [innerHTML]="'Continue'"
      ></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>

@if (addPropertyForm.valid) {
  <div id="trigger-tour"></div>
}
